import { ECreditApplicationStep } from '@if/core/types'
import { FilteredCreditApplication } from '@src/api/credit-api'
import UploadFilesTable from '@src/components/UploadFilesTable'
import { hasMissingDocuments } from '@src/data/credit-application-selectors'
import { Trans, useTranslation } from 'react-i18next'
import UnderReviewTile from '../../components/UnderReviewTile'

interface Props {
  creditApp: FilteredCreditApplication
}
const FailedToObtainCreditReportFormV1 = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const hasMissingDocs = hasMissingDocuments(creditApp, ECreditApplicationStep.Credit)

  return (
    <main className="general-message" style={{ paddingTop: 0 }}>
      {hasMissingDocs && (
        <>
          <div style={{ textAlign: 'center' }}>
            <h4 className="subtitle">{t('common.financeApplication')}</h4>
          </div>
          <h1>{t('identity.cannotConfirm')}</h1>
          <div className="paragraph">
            <p>
              <Trans i18nKey="identity.hereToHelp" />
            </p>
            <p>{t('identity.notifyEmail')}</p>
            <p>{t('identity.consent')}</p>
          </div>
        </>
      )}
      {hasMissingDocs && <UploadFilesTable creditApp={creditApp} />}
      {!hasMissingDocs && <UnderReviewTile />}
    </main>
  )
}

export default FailedToObtainCreditReportFormV1
